<template>
  <footer class="app-footer">
    <span><a href="https://www.esm.com">ESM</a> &copy; 2018 Event Sponsorship Management.</span>
    <span class="ml-auto">Powered by <a href="https://www.esm.com">ESM</a></span>
  </footer>
</template>
<script>
export default {
  name: 'c-footer'
}
</script>



// WEBPACK FOOTER //
// src/components/SiteFooter.vue